<!-- 短视频社交 -->
<template>
  <div class="warp">
    <div class="banner">
      <p>绿茶短视频社交系统</p>
      <span>
        撬动年轻人的“短视频+
        <br />社交”市场
      </span>
      <a class="button-text" target="_blank" href="https://work.weixin.qq.com/kfid/kfc4a1a89c3395408e9">微信客服</a>
    </div>
    <div class="section">
      <div class="tis">绿茶短视频社交系统，助力企业进军5G时代的短视频+社交功能。趣味的随拍视频结合无压力的熟人社交，贴近年轻人的社交需求，帮助用户记录、发现和交流生活的乐趣。</div>
      <div class="title">特色功能</div>
      <div class="item">
        <div class="subTitle">
          <h2>
            <img src="../../assets/images/short03.png" />
            <span>会话群聊</span>
          </h2>
          <h3>丰富多元的聊天方式，满足用户间的及时沟通</h3>
        </div>
        <div class="img">
          <img src="../../assets/images/short04.png" />
        </div>
        <ul class="list">
          <li>
            <div class="left">
              <img src="../../assets/images/short05.png" />
            </div>
            <div class="right">
              <span>多元沟通</span>
              <p>文字、图片、表情、语音、文件、红包等丰富多元的聊天方式，满足用户间的即时沟通。</p>
            </div>
          </li>
          <li>
            <div class="left">
              <img src="../../assets/images/short06.png" />
            </div>
            <div class="right">
              <span>社群会话</span>
              <p>支持组建万人社群，可邀请微信/QQ好友群聊、导入通讯录好友，快速发展熟人社交。</p>
            </div>
          </li>
          <li>
            <div class="left">
              <img src="../../assets/images/short07.png" />
            </div>
            <div class="right">
              <span>红包互动</span>
              <p>支持一对一红包、群聊红包，也可结合短视频玩转红包视频，提高互动性和活跃度。</p>
            </div>
          </li>
        </ul>
      </div>

      <div class="item">
        <div class="subTitle">
          <h2>
            <img src="../../assets/images/short08.png" />
            <span>视频随拍</span>
          </h2>
          <h3>闪电记录多彩生活，多种趣味功能让视频拍摄更创意</h3>
        </div>
        <div class="img">
          <img src="../../assets/images/short09.png" />
        </div>
        <ul class="list">
          <li>
            <div class="left">
              <img src="../../assets/images/short10.png" />
            </div>
            <div class="right">
              <span>趣味特效</span>
              <p>多款滤镜、创意贴纸，降低拍摄视频门槛，拍出更有趣好玩的视频。</p>
            </div>
          </li>
          <li>
            <div class="left">
              <img src="../../assets/images/short11.png" />
            </div>
            <div class="right">
              <span>海量配乐</span>
              <p>海量音乐库，支持覆盖原声，随心拍出热门小视频，让视频更具趣味。</p>
            </div>
          </li>
          <li>
            <div class="left">
              <img src="../../assets/images/short12.png" />
            </div>
            <div class="right">
              <span>分享转发</span>
              <p>快速分享至视频广场或我的随拍（仅好友可见），也可转发给指定好友。</p>
            </div>
          </li>
        </ul>
      </div>

      <div class="item item2">
        <div class="subTitle">
          <h2>
            <img src="../../assets/images/short15.png" />
            <span>视频广场</span>
          </h2>
          <h3>在这里查看更多有趣的视频动态，发现更多生活精彩</h3>
        </div>
        <div class="img">
          <img src="../../assets/images/short16.png" />
        </div>
        <ul class="list">
          <li>
            <div class="left">
              <img src="../../assets/images/short17.png" />
            </div>
            <div class="right">
              <span>评论点赞</span>
              <p>可对好友的随拍视频进行点赞、发表评论，好友之间的点赞评论皆可见。</p>
            </div>
          </li>
          <li>
            <div class="left">
              <img src="../../assets/images/short18.png" />
            </div>
            <div class="right">
              <span>限时可见</span>
              <p>视频内容限时可见，超过时间转为仅自己可见，进一步降低社交压力。</p>
            </div>
          </li>
          <li>
            <div class="left">
              <img src="../../assets/images/short19.png" />
            </div>
            <div class="right">
              <span>动态推荐</span>
              <p>实时推荐好友的视频动态，一键查看好友最新发布的小视频，帮助突破社交圈层。</p>
            </div>
          </li>
        </ul>
      </div>

      <div class="title" style="margin-top:.7rem;">营销玩法</div>
      <ul class="btmList">
        <li>
          <img src="../../assets/images/short20.png" />
          <span>发视频赚金币</span>
          <p>
            用户发布随拍即可获得金币，
            <br />金币可用于抽奖、兑奖，
            <br />从而提升平台活跃度。
          </p>
        </li>
        <li>
          <img src="../../assets/images/short21.png" />
          <span>扭蛋机抽奖</span>
          <p>
            用户可使用金币参与抽奖活
            <br />动，吸引用户通过不断做任务
            <br />获得金币，沉淀更多粉丝。
          </p>
        </li>
        <li>
          <img src="../../assets/images/short22.png" />
          <span>视频红包营销</span>
          <p>
            发布祝福视频，好友观看
            <br />后，双方都能领到红包，红
            <br />包营销快速带动平台热度。
          </p>
        </li>
        <li>
          <img src="../../assets/images/short23.png" />
          <span>邀请好友领红包</span>
          <p>
            快速生成邀请码，成功邀请
            <br />好友登录可获得红包，
            <br />以老带新高效获客。
          </p>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "shortVideo",

  data() {
    return {};
  },
  mounted() {},

  methods: {}
};
</script>
<style lang='less' scoped>
.warp {
  background-color: #fff;
  padding-top: 1.45rem;
  box-sizing: border-box;
  padding-bottom: 1.2rem;
  .banner {
    background: url("../../assets/images/short01.jpg") no-repeat left top;
    background-size: 100% auto;
    height: 7rem;
    padding: 0 0.5rem;
    padding-top: 2rem;
    color: #fff;
    p {
      font-size: 0.6rem;
    }
    span {
      font-size: 0.36rem;
      line-height: 0.6rem;
      display: block;
      padding-top: 0.2rem;
    }
    a {
      background-color: #fff;
      width: 3rem;
      height: 0.9rem;
      text-align: center;
      color: #310379;
      font-size: 0.36rem;
      border-radius: 0.9rem;
      margin-top: 0.5rem;
      line-height: .9rem;
      display: block;
    }
  }
  .section {
    .tis {
      padding: 0.7rem 0.5rem;
      font-size: 0.3rem;
      color: #666;
      line-height: 0.55rem;
    }
    .title {
      height: 1.4rem;
      background: url("../../assets/images/short02.png") no-repeat center center;
      background-size: 100% auto;
      text-align: center;
      line-height: 1.4rem;
      font-size: 0.48rem;
      color: #262e43;
      font-weight: 600;
    }
    .item {
      padding-bottom: 0.8rem;
      .subTitle {
        h2 {
          margin-bottom: 0.3rem;
          height: 0.7rem;
          line-height: 0.8rem;
          text-align: center;
          img {
            width: 0.7rem;
            height: 0.7rem;
          }
          span {
            font-size: 0.4rem;
            font-weight: 500;
          }
        }
        h3 {
          text-align: center;
          color: #888;
          font-size: 0.36rem;
          font-weight: 400;
        }
      }
      .img {
        padding: 0.3rem 0;
        img {
          width: 100%;
        }
      }
      .list {
        padding: 0 1.3rem 0 0.7rem;
        li {
          display: flex;
          padding-bottom: 0.5rem;
          .left {
            padding-right: 0.2rem;
            img {
              display: block;
              width: 0.9rem;
              height: 0.9rem;
            }
          }
          .right {
            flex: 1;
            span {
              font-size: 0.36rem;
              color: #000;
              font-weight: 600;
              line-height: 0.7rem;
            }
            p {
              color: #888;
              font-size: 0.34rem;
              line-height: 0.6rem;
            }
          }
        }
      }
    }
    .item2 {
      background-image: url("../../assets/images/short13.jpg"),
        url("../../assets/images/short14.jpg");
      background-repeat: no-repeat, no-repeat;
      background-size: 100% auto, 100% auto;
      background-position: left top, left bottom;
      background-color: #f4f2ff;
      padding-top: 1.5rem;
      padding-bottom: 1.3rem;
    }
    .btmList{
        display: flex;
            flex-wrap: wrap;
        li{
            width: 50%;
            text-align: center;
            padding: .3rem 0;
            img{
                width: 1.96rem;
                height: 1.96rem;
            }
            span{
                font-size: .36rem;
                color: #000;
                font-weight: 500;
                display: block;
                padding: .2rem 0;
            }
            p{
                font-size: .32rem;
                color: #888;
                line-height: .55rem;
            }
        }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/view/product/socialContact.vue